import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import profileReducer from "./slices/profileSlice";
import productsReducer from "./slices/productsSlice";
import cartReducer from "./slices/cartSlice";
import paymentsReducer from "./slices/paymentsSlice";
import walletReducer from "./slices/walletSlice";
import commissionsReducer from "./slices/commissionsSlice";
import notificationsReducer from "./slices/notificationsSlice";
import referralTreeReducer from "./slices/referralTreeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    products: productsReducer,
    cart: cartReducer,
    payments: paymentsReducer,
    wallet: walletReducer,
    commissions: commissionsReducer,
    notifications: notificationsReducer,
    referralTree: referralTreeReducer,
  },
});
